import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { UserFieldsStore } from '@fry/lib/user-fields';
import { ListService } from '@fry/lib/list';
import { UserFieldsSearch } from '@fry/components/user-fields/user-fields.search';
import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';
import { of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
    selector: 'app-user-field-list',
    templateUrl: './user-field-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserFieldListComponent implements OnInit, OnDestroy {

  public items$ = this.list.items;

  public actions: EASLinkAction[] = [{
    type: 'link',
    label: $localize `New user field`,
    condition: () => {
      return of(true);
    },
    link: of(['add']),
    color: 'primary',
  }];

  private destroyed$ = new Subject<void>();

  constructor(
    private userFields: UserFieldsStore,
    private search: UserFieldsSearch,
    public list: ListService
  ) { }

  ngOnInit() {
    this.list.setupWith(this.userFields, this.search)
             .pipe(takeUntil(this.destroyed$))
             .subscribe();
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
